module.exports = __webpack_public_path__ + "static/img/top-img3.4feca1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mt_img/top-img3.png
// module id = zRJa
// module chunks = 0